import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferClosePayload } from 'api/actions/price-offer-close/price-offer-close-payload';
import { PriceOfferClosePathParameters } from 'api/actions/price-offer-close/price-offer-close-path-parameters';
import { PriceOfferCloseResponse } from 'api/actions/price-offer-close/price-offer-close-response';

type PriceOfferCloseQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferClose action.
 */
export const priceOfferCloseActionPath = new SweetPath<keyof PriceOfferClosePathParameters>(
  '/api/price-offer/close/{priceOfferId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferClose actions.
 */
export default function createPriceOfferCloseAction(axios: AxiosInstance) {
  return function priceOfferCloseAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PriceOfferClosePathParameters;
    query?: PriceOfferCloseQueryParameters;
    payload: PriceOfferClosePayload;
  }) {
    const path = priceOfferCloseActionPath.insert(parameters);

    return axios.request<PriceOfferCloseResponse, PriceOfferCloseResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
